import React, { Component } from "react";
import { Button, Modal } from "react-bootstrap";
import { css } from "aphrodite";
import styles from "./style";
import { getValue } from "@testing-library/user-event/dist/utils";
import "./CustomModal.css";

class CustomModal extends Component {
  handleChange = (val, fieldName, callback) => {
    callback(fieldName, val);
  };
  render() {
    const {
      name,
      action,
      header,
      title,
      show,
      size,
      close,
      save,
      confirmButtons = true,
      closeButton,
      type,
    } = this.props;
    const bgClass = type==='warning'?styles.warningModalHeaderBackground:(type==='error'?styles.errorModalHeaderBackground:'');
    return (
      <div>
        <Modal
          size={size}
          show={show}
          onHide={close}
          centered={true}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header className={header !== "" ? css(styles.modalHeader, bgClass) : css(styles.withoutHeaderClass)}  closeButton={closeButton} closeVariant="white">
            <Modal.Title className={css(styles.modalTitle)}>{header}</Modal.Title>
          </Modal.Header>
          <Modal.Body className={css(styles.modalBody)}>
            <span style={{textAlign:'left', display:'inline-block'}} dangerouslySetInnerHTML={{__html:title}}/>
          </Modal.Body>
          <Modal.Footer className={css(styles.modalFooter)}>
            {confirmButtons ? (
              <>
                <Button
                  className={css(styles.buttonStyle)}
                  variant="primary"
                  onClick={() => this.handleChange(true, name, action)}
                >
                  Yes
                </Button>
                <Button
                  className={css(styles.buttonStyle)}
                  variant="secondary"
                  onClick={() => this.handleChange(false, name, action)}
                >
                  No
                </Button>
              </>
            ) : (
              <Button
                className={css(styles.buttonStyle)}
                style={{textAlign: "center"}}
                variant="primary"
                onClick={() => this.handleChange(true, name, action)}
              >
                Ok
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default CustomModal;
